export default {
    "baskets": {
        "baskets": "Paniers",
        "addToBasket": "Ajouter au panier",
        "removeFromBasket": "Supprimer du panier",
        "removeFromAllBaskets": "Supprimer de tous les paniers",
        "removeFromAllBasketsConfirmation": "Êtes-vous sûr de vouloir supprimer ce résultat de ces paniers : {baskets} ?",
        "basketAlreadyExists": "Un panier avec ce nom existe déjà. Voulez-vous le remplacer ?",
        "noBasket": "Vous n'avez pas encore ajouté de document à un panier...",
        "createBasket": "Créer un panier",
        "manageBaskets": "Gérer les paniers",
        "delete": "Supprimer ce panier"
    },

    "editBasket": {
        "title": "Panier",
        "name": "Nom"
    },

    "manageBaskets": {
        "title": "Gérer les paniers",
        "save": "Enregistrer",
        "reorder": "Réorganiser",
        "remove": "Effacer",
        "removeAll": "Effacer tout",
        "name": "Nom",
        "tooltip": {
            "export": "Exporter ce panier"
        }
    },

    "selectBasket": {
        "title": "Sélectionner un panier",
        "newBasket": "Nouveau panier..."
    },

};
